import Vue from 'vue';
import VueI18n from 'vue-i18n';
import defaultLanguageConf from './languages/default.config.js';

export const loadLocaleMessages = function (locale) {
  // 预定义语言包文件和它们路径的映射
  const messageFiles = {
    en: () => import('./languages/modules/en/index.js'),
    zh: () => import('./languages/modules/zh/index.js')
  };
  // 检查是否有这个语言包
  const loadMessageFile = messageFiles[locale];
  if (!loadMessageFile) {
    return Promise.reject(new Error(`Language pack for ${locale} not found`));
  }

  // 加载语言包
  return loadMessageFile()
    .then(messages => {
      i18n.setLocaleMessage(locale, messages.default);
      i18n.locale = locale;

      // vhall-ui组件国际化支持
      VHALLUI.locale({ el: i18n.messages[locale].el });

      const bodyEle = document.querySelector('body');
      if (bodyEle) {
        bodyEle.classList.add(`is-${locale}`);
      }

      return locale;
    })
    .catch(error => {
      console.error(`Failed to load language pack for ${locale}:`, error);
      // 可能希望在这里处理错误
    });
};
let i18n = window.i18n;
if (!i18n) {
  Vue.use(VueI18n);
  // Vuei18n增加方法，匹配不到code返回undefined
  Vue.prototype.$tec = function (code) {
    if (this.$te(code)) {
      return this.$t(code);
    } else {
      const errorKey = `errorMap[${code}]`;
      return this.$te(errorKey) ? this.$t(errorKey) : undefined;
    }
  };

  Vue.prototype.$tdefault = function (key) {
    if (this.$t) {
      return defaultLanguageConf[key] ? this.$t(defaultLanguageConf[key]) : key;
    } else {
      return defaultLanguageConf[key] ? this.t(defaultLanguageConf[key]) : key;
    }
  };

  i18n = new VueI18n({
    locale: window.$globalConfig.currentLang || 'zh',
    messages: {}
  });
  window.i18n = i18n;
}

export default i18n;
